import React, { UIEvent, useEffect, useRef, useState } from 'react';
import { NavigationItemProps } from '../../../../../../../components/Layouts/Headers/HeaderComponents/HeaderNavigation/components/NavigationItem/NavigationItem.typed';

const useNavigationItem = (option: NavigationItemProps) => {
  const items = option.items;
  const hasSubmenu = !!items;
  const [submenuIsOpen, setSubmenuOpen] = useState(true);

  const handleClick = React.useCallback(
    (e: UIEvent) => {
      if (hasSubmenu) return;

      e.stopPropagation();
    },
    // TODO: Clean up this effect's dependencies. We're disabling this lint error for now so we can
    // clean up the lint logs. Ideally we should rewrite this code to be less error prone and trust
    // the lint rule's judgement.
    // https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=userstory/98606
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasSubmenu, option],
  );

  const submenuRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    const submenuElement = submenuRef.current;

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const isHTMLElement = entry.target instanceof HTMLElement;
        if (isHTMLElement) {
          setSubmenuOpen(entry.target.offsetWidth > 0);
        }
      });
    });

    if (submenuElement) {
      observer.observe(submenuElement);
    }

    return () => {
      if (submenuElement) {
        observer.unobserve(submenuElement);
      }
    };
  }, []);

  return {
    submenuRef,
    items,
    hasSubmenu,
    setSubmenuOpen,
    submenuIsOpen,
    handleClick,
  };
};

export { useNavigationItem };
